import React from 'react';
import EcosystemFeatures from '../components/EcosystemFeatures';

const RoadmapPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <main>

        {/* The Continuity Flow Section */}
        <EcosystemFeatures />

      </main>
    </div>
  );
};

export default RoadmapPage;